import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Section, StatusChip, fmtL, btnS } from "./BpKit";

const BranchRow = ({ b, people }) => {
  const team = people.filter((p) => p.branches.includes(b.branch)).reduce((a, p) => a + p.total, 0);
  return (
    <div className="border border-slate-300 rounded-sm p-3 bg-white" data-testid={`bp-team-branch-${b.branch}`}>
      <div className="flex items-center justify-between gap-2"><span className="font-medium text-sm">{b.label} branch plan</span><StatusChip s={b.status} tid={`bp-team-branch-status-${b.branch}`} /></div>
      <div className="num text-sm mt-2">Branch target <b>{fmtL(b.total)}</b> · Salespeople's plans <b>{fmtL(Math.round(team * 100) / 100)}</b></div>
    </div>
  );
};

export const TeamReview = ({ fy, onOpen }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/bp/plans", { params: { fy } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [fy]);
  if (!d) return null;
  const waiting = d.people.filter((p) => p.status === "submitted" && p.can_approve).length;
  return (
    <div className="space-y-4" data-testid="bp-team-review">
      {d.branch.length > 0 && <div className="grid sm:grid-cols-2 gap-3">{d.branch.map((b) => <BranchRow key={b.branch} b={b} people={d.people} />)}</div>}
      <Section tid="bp-team-plans" title="Team sales plans" hint={waiting ? `${waiting} plan${waiting > 1 ? "s" : ""} waiting for your approval` : "Each salesperson proposes their plan; their manager approves it."}>
        <div className="overflow-x-auto">
          <table className="ax-table w-full" data-testid="bp-team-plans-table">
            <thead><tr><th>Person</th><th>Branch</th><th>Status</th><th className="text-right">FY plan</th><th className="text-right">Accounts</th><th>Last saved</th><th /></tr></thead>
            <tbody>
              {d.people.map((p) => (
                <tr key={p.user_id} data-testid={`bp-team-row-${p.user_id}`} className={p.status === "submitted" && p.can_approve ? "bg-sky-50/60" : ""}>
                  <td className="font-medium">{p.name}</td>
                  <td className="text-xs">{p.branches.map((b) => (b === "DEL" ? "Delhi (FBD)" : "Mumbai")).join(", ")}</td>
                  <td><StatusChip s={p.status} tid={`bp-team-status-${p.user_id}`} /></td>
                  <td className="text-right num">{fmtL(p.total)}</td>
                  <td className="text-right num">{p.accounts}</td>
                  <td className="text-xs text-slate-500">{p.updated_at ? new Date(p.updated_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" }) : "—"}</td>
                  <td className="text-right"><button type="button" className={`${btnS} h-8`} onClick={() => onOpen(p.user_id)} data-testid={`bp-team-open-${p.user_id}`}>{p.status === "submitted" && p.can_approve ? "Review" : "Open"}</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>
    </div>
  );
};
